/* --------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

import moment from 'moment';
import _ from 'lodash';

const pad = v => {
  return _.padStart(Math.floor(v).toFixed(0),2,'0');
};
const time = t => {
  if (t < 3600) {
    return `${pad(t/60)}:${pad(t%60)}`;
  }
  return `${pad(t/3600)}:${pad((t/60)%60)}:${pad(t%60)}`;
};
const timeTenths = t => {
  const tenths = String(Math.floor(t*10)).substr(-1);
  return `${time(t)}.${tenths}`;
};
const date = d => {
  if (!d) {
    return '';
  }
  return moment(d).format('lll');
};
const dateShort = d => {
  if (!d) {
    return '';
  }
  return moment(d).format('ll');
};
const arrayToHTML = a => {
  if (!a) {
    return '';
  }
  return a.join('<br><br>');
};
const startCase = s => {
  return _.startCase(s);
};
const momentDuration = d => {
  if (!d) {
    return;
  }
  const ts = _.filter(['years', 'months', 'weeks', 'days', 'hours'], unit => d[unit] > 0);
  return _.map(ts, unit => {
    return d[unit] > 1 ? `${d[unit]} ${unit}` : `${d[unit]} ${unit.replace(/s$/,'')}`;
  }).join(' and ');
};
const capitalize = (value) => {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
};
const truncate25 = (value) => {
  if (!value || !value.length) return '';
  if (value.length <= 28) return value;
  return value.substr(0, 25) + '...';
};

export default {
  capitalize,
  time,
  timeTenths,
  date,
  dateShort,
  arrayToHTML,
  startCase,
  momentDuration,
  truncate25,
};
